export enum CustomError {
  CancelPolling = 'CANCEL_POLLING',
  MissingLookingForCollabCategory = 'MISSING_LOOKING_FOR_COLLABORATOR_CATEGORY',
}
